<template>
  <div class="timeslots-dropdown">
    <el-radio-group v-model="selectedId">
      <template v-for="(timeslot, index) in timeslots" :key="timeslot.id">
        <div class="timeslots-dropdown__timeslot" @click="clickTimeslotHandler(timeslot.id)">
          {{ minutesToHHMM(timeslot.von) }}
          <el-radio :label="timeslot.id" />
        </div>
        <hr v-if="index !== timeslots.length - 1" />
      </template>
    </el-radio-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { minutesToHHMM } from '@/utils/format.js'

export default {
  emits: ['dropdownSelection'],
  props: {
    timeslots: {
      type: Array,
    },
  },
  data() {
    return {
      selectedId: null,
    }
  },
  computed: {
    ...mapGetters(['isMobile', 'selectedTimeslot']),
  },
  watch: {
    selectedId() {
      if (this.selectedId) {
        this.$emit(
          'dropdownSelection',
          this.timeslots.find((timeslot) => timeslot.id === this.selectedId)
        )
      }
    },
    selectedTimeslot() {
      if (
        this.selectedTimeslot &&
        !this.timeslots.map((slot) => slot.id).includes(this.selectedTimeslot[0].id)
      )
        this.selectedId = null
    },
  },
  methods: {
    minutesToHHMM,
    clickTimeslotHandler(timeslotId) {
      this.selectedId = timeslotId
      this.closeTimeslotDropdown()
    },
    closeTimeslotDropdown() {
      // simulate click away for popover
      if (this.isMobile) {
        document.querySelector('.timeslots-mobile__selection__body__slot--active').click()
      } else {
        document.querySelector('.timeslots-desktop__column__body__slot--active').click()
      }
    },
  },
}
</script>

<style lang="scss">
.timeslots-dropdown {
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  overflow: hidden;

  @media (max-width: $breakpoint-max-tablet) {
    font-size: 16px;
  }

  &__timeslot {
    @include flex-center-align;
    justify-content: space-between;
    cursor: pointer;
    padding: 8px 16px;

    @media (max-width: $breakpoint-max-tablet) {
      padding: 12px 16px;
    }

    &:hover {
      background-color: rgba($color-grey-light, 0.3);
    }

    .el-radio {
      height: 16px;

      @media (max-width: $breakpoint-max-tablet) {
        height: 24px;
      }

      &__inner {
        height: 16px;
        width: 16px;

        @media (max-width: $breakpoint-max-tablet) {
          height: 24px;
          width: 24px;
        }
      }

      &.is-checked {
        .el-radio__inner {
          &::after {
            @media (min-width: $breakpoint-tablet) {
              height: 8px;
              width: 8px;
            }
          }
        }
      }
    }
  }
}
</style>
